import { Cooperativa, EntidadesFinancieras, IPaymentMethod, PaymentMethodEnum } from "@/shared/interfaces";
import CustomAutocomplete from "../CustomAutocomplete";
import { EntidadFinancieraENUM, fnMostrarTipoTarjeta, gridSizeMdLg12, gridSizeMdLg6, texto, TIPO_CUENTA_BANCARIA_CHOICE, TipoCuentaBancariaEnumChoice } from "@/shared";
import { usePaymentMethodsStore } from "@/store/erp/system-settings/payment-methods";
import { useForm, UseFormReturn } from "react-hook-form";
import useFormaPago from "./useFormaPago";
import CustomAutocompleteArrString from "../CustomAutocompleteArrString";
import CustomTextFieldNumberComponente, { TiposTextFieldNumberEnum } from "../CustomTextFieldNumberComponente";
import SampleDatePicker from "../SampleDatePicker";
import dayjs from "dayjs";
import { Grid } from "@mui/material";
import { useEffect } from "react";

interface Props {
    form: UseFormReturn<any>;
    onlyShow?: boolean;
    onChangeData?: (data: any) => void;
}

/**
 * Añade al formulario los campos de forma de pago:
 * entidad_financiera_aux, codigo_forma_pago_aux, tipo_contrato_aux, tarjeta_aux, 
 * valor_instalacion_total_aux, valor_instalacion_aux, valor_instalacion_iva_aux, 
 * numero_cuenta_aux, tipo_cuenta_bancaria_aux, numero_tarjeta_aux
 * @param form 
 * @returns void
 */
const FormaPago = ({
    form,
    onlyShow = false,
    onChangeData
}: Props) => {
    // const [paymentMethods, setPaymentMethods] = useState<IPaymentMethod[]>([]);
    const formFormaPago = useForm()



    
    const {
        // getpaymentMethodsFilterPaging,
        paymentMethodsFilterPaging: paymentMethods,
    } = usePaymentMethodsStore()

    const {
        handleFormaPagoServicio,
        dataCooperativaServicio,
        isLoadingCooperativaServicio,
        tipoTarjetaServicio,
        isLoadingEntidadFinancieroServicio,
        dataEntidadFinancieroServicio,
    } = useFormaPago({form:formFormaPago})

    // useEffect(() => {
    //     if(habilitarLecturaPrevia) {
    //         form.reset({
    //             ...form.getValues(),
    //             forma_pago_aux: form.getValues()?.forma_pago_adicionales_tecnico?.forma_pago,
    //             metodo_pago_mensualidad_aux: form.getValues()?.forma_pago_adicionales_tecnico?.metodo_pago_mensualidad,
    //             valor_instalacion_total_aux: form.getValues()?.forma_pago_adicionales_tecnico?.valor_instalacion_total,
    //             valor_instalacion_aux: form.getValues()?.forma_pago_adicionales_tecnico?.valor_instalacion,
    //             valor_instalacion_iva_aux: form.getValues()?.forma_pago_adicionales_tecnico?.valor_instalacion_iva,
    //             numero_cuenta_aux: form.getValues()?.forma_pago_adicionales_tecnico?.numero_cuenta,
    //             tipo_cuenta_bancaria_aux: form.getValues()?.forma_pago_adicionales_tecnico?.tipo_cuenta_bancaria,
    //             numero_tarjeta_aux: form.getValues()?.forma_pago_adicionales_tecnico?.numero_tarjeta,
    //             entidad_financiera_aux: form.getValues()?.forma_pago_adicionales_tecnico?.entidad_financiera,
    //             codigo_forma_pago_aux: form.getValues()?.forma_pago_adicionales_tecnico?.codigo_forma_pago,
    //             tipo_contrato_aux: form.getValues()?.forma_pago_adicionales_tecnico?.tipo_contrato,
    //             tarjeta_aux: form.getValues()?.forma_pago_adicionales_tecnico?.tarjeta,
    //         })
    //     }
    // }, [form.getValues().forma_pago_aux])

    useEffect(() => {
        formFormaPago.reset({
            ...form.getValues()
        })
    }, [])
    useEffect(() => {
        form.reset({
            ...formFormaPago.getValues()
        })
        if(onChangeData) {
            onChangeData(formFormaPago.getValues())
        }
    }, [formFormaPago.getValues()])

    return (
    <Grid {...gridSizeMdLg12} container item spacing={2}>
        <CustomAutocomplete<IPaymentMethod>
            required={false}
            size={gridSizeMdLg12}
            label={texto.forma_pago}
            name="forma_pago_aux"
            // options
            options={paymentMethods || []}
            valueKey="alias"
            actualValueKey="codigo"
            defaultValue={formFormaPago.getValues().forma_pago_aux || ""}
            isLoadingData={false}
            // validation
            control={formFormaPago.control}
            error={form?.formState.errors.forma_pago_aux as any}
            helperText={form?.formState.errors.forma_pago_aux?.message as any}
            onChangeRawValue={(e) => {
                console.log(e)
                formFormaPago.reset({
                    ...formFormaPago.getValues(),
                    metodo_pago_mensualidad_aux: e.codigo
                })
                handleFormaPagoServicio(e)
            }}
            disabled={onlyShow}
        />

        {formFormaPago.getValues().codigo_forma_pago_aux == PaymentMethodEnum.DEBITO
            && (
            <>
                <CustomAutocompleteArrString
                    size={gridSizeMdLg6}
                    label={texto.tipo_cuenta}
                    name="tipo_cuenta_bancaria_aux"
                    options={
                        formFormaPago.getValues().entidad_financiera_aux ==
                        EntidadFinancieraENUM.GUAYAQUIL
                        ? TIPO_CUENTA_BANCARIA_CHOICE
                        : TIPO_CUENTA_BANCARIA_CHOICE.filter(
                            (e) => e != TipoCuentaBancariaEnumChoice.AMIGA
                        ) || []
                    }
                    defaultValue={
                        formFormaPago.getValues().tipo_cuenta_bancaria_aux
                        || formFormaPago.getValues().tipo_cuenta_aux
                    }
                    isLoadingData={false}
                    control={formFormaPago.control}
                    error={form?.formState.errors.tipo_cuenta_bancaria_aux as any}
                    helperText={form?.formState.errors.tipo_cuenta_bancaria_aux?.message as any}
                    onChangeValue={(e) => {
                        formFormaPago.reset({
                        ...formFormaPago.getValues(),
                        tipo_cuenta_aux: e,
                        });
                    }}
                    disabled={onlyShow}
                />

                {!isLoadingCooperativaServicio &&
                dataCooperativaServicio?.length != 0 && (
                    <CustomAutocomplete<Cooperativa>
                        size={gridSizeMdLg6}
                        label={texto.cooperativa}
                        name="cooperativa_aux"
                        // options
                        options={dataCooperativaServicio || []}
                        valueKey="nombre" // name is the fk
                        actualValueKey="codigo"
                        defaultValue={
                            formFormaPago.getValues().cooperativa_aux || ""
                        }
                        isLoadingData={isLoadingCooperativaServicio}
                        // validation
                        control={form?.control}
                        error={form?.formState.errors.cooperativa_aux as any}
                        helperText={form?.formState.errors.cooperativa_aux?.message as any}
                        onChangeValue={(e) => {
                            formFormaPago.reset({ ...formFormaPago.getValues(), cooperativa_aux: e });
                        }}
                        disabled={onlyShow}
                    />
                )}

                <CustomTextFieldNumberComponente
                    type={TiposTextFieldNumberEnum.TARJETA}
                    size={gridSizeMdLg12}
                    label={texto.numero_cuenta}
                    error={form?.formState.errors.numero_cuenta_aux as any}
                    helperText={form?.formState.errors.numero_cuenta_aux?.message as any}
                    control={formFormaPago.control}
                    name="numero_cuenta_aux"
                    defaultValue={formFormaPago.getValues().numero_cuenta_aux}
                    max={25}
                    onChangeValue={(e) => {
                        formFormaPago.reset({ ...formFormaPago.getValues(), numero_cuenta_aux: e });
                    }}
                    disabled={onlyShow}
                />
            </>
        )}

        {formFormaPago.getValues().codigo_forma_pago_aux ==
            PaymentMethodEnum.TARJETA && (
            <>
                <CustomAutocomplete<EntidadesFinancieras>
                    size={gridSizeMdLg6}
                    label={texto.entidad_finciera}
                    name="entidad_financiera_aux"
                    // options
                    options={dataEntidadFinancieroServicio?.data.data || []}
                    valueKey="nombre" // name is the fk
                    actualValueKey="codigo"
                    defaultValue={
                        formFormaPago.getValues().entidad_financiera_aux || ""
                    }
                    isLoadingData={isLoadingEntidadFinancieroServicio}
                    // validation
                    control={formFormaPago.control}
                    error={form?.formState.errors.entidad_financiera_aux as any}
                    helperText={form?.formState.errors.entidad_financiera_aux?.message as any}
                    onChangeValue={(e) => {
                        formFormaPago.reset({
                            ...formFormaPago.getValues(),
                            entidad_bancaria_aux: e,
                        });
                    }}
                    disabled={onlyShow}
                />

                <SampleDatePicker
                    format="YYYY-MM"
                    views={["year", "month"]}
                    label="Fecha Caducidad"
                    name="tarjeta_fecha_caducidad_aux"
                    minDate={dayjs(new Date())}
                    control={formFormaPago.control}
                    defaultValue={
                        formFormaPago.getValues().tarjeta_fecha_caducidad_aux ??
                        ""
                    }
                    error={form?.formState.errors.tarjeta_fecha_caducidad_aux as any}
                    helperText={form?.formState.errors.tarjeta_fecha_caducidad_aux?.message as any}
                    size={gridSizeMdLg6}
                    onChangeValue={(e) => {
                        formFormaPago.reset({
                            ...formFormaPago.getValues(),
                            fecha_caducidad_tarjeta_aux: e,
                        });
                    }}
                    disabled={onlyShow}
                />

                <CustomTextFieldNumberComponente
                type={TiposTextFieldNumberEnum.TARJETA}
                startAdornment={
                    fnMostrarTipoTarjeta(tipoTarjetaServicio) ? (
                    <img
                        src={fnMostrarTipoTarjeta(tipoTarjetaServicio)}
                        alt="imge-tarjeta"
                        width={"50px"}
                    />
                    ) : null
                }
                size={gridSizeMdLg12}
                label={texto.ingresar_num_tarjeta}
                error={form?.formState.errors.numero_tarjeta_aux as any}
                helperText={form?.formState.errors.numero_tarjeta_aux?.message as any}
                control={formFormaPago.control}
                name="numero_tarjeta_aux"
                defaultValue={
                    formFormaPago.getValues().numero_tarjeta_aux ?? ""
                }
                max={24}
                onChangeValue={(e) => {
                    formFormaPago.reset({ ...formFormaPago.getValues(), numero_tarjeta_aux: e });
                }}
                disabled={onlyShow}
                />
            </>
        )}
    </Grid>
  )
}

export default FormaPago